import { memo, useCallback } from 'react';
import {
  Header,
  HeaderCentreSection,
  HeaderLeftSection,
  HeaderRightSection,
} from '@picsart/editorlayout';
import { Button, ButtonSizeMD, ButtonVariants } from '@picsart/button';
import IconTickLarge from '@picsart/icons/IconTickLarge';
import { useTranslator } from '@picsart/rc/services/localization';
import Logo from '@picsart/logo/Logo';
import View from '@picsart/view/View';
import { getContext } from '@picsart/miniapps-sdk';

import { BATCH_TOOLS } from 'pages/Batch/configs';
import useBatchData from 'pages/Batch/sections/Context/useBatchData';
import useToolCancelApply from 'hooks/useToolCancelApply';
import { PICSART_URL } from 'configs/constants';
import { DesktopExport } from 'pages/Batch/components/Export';

import testIds from './testIds';

const DesktopHeader = () => {
  const translate = useTranslator();
  const { activeTool, data, selectedData } = useBatchData();
  const { handleCancel, handleDone, isDone, isToolApplying } = useToolCancelApply();

  const redirectHomePage = useCallback(async () => {
    await getContext().handlers.close();
    window.parent.location.href = PICSART_URL;
  }, []);

  return (
    <Header>
      <HeaderLeftSection>
        <View onClick={redirectHomePage} style={{ cursor: 'pointer' }}>
          <Logo />
        </View>
      </HeaderLeftSection>
      <HeaderCentreSection />
      <HeaderRightSection>
        {activeTool && activeTool !== BATCH_TOOLS.upload ? (
          <>
            <Button
              variant={ButtonVariants.Outline}
              dataTestId={testIds.cancelBtn}
              onClick={handleCancel}
              size={ButtonSizeMD}
            >
              {translate('Cancel')}
            </Button>
            <Button
              isDisabled={!isDone || isToolApplying}
              dataTestId={testIds.applyBtn}
              endIcon={IconTickLarge}
              onClick={handleDone}
              size={ButtonSizeMD}
            >
              {translate('Apply')}
            </Button>
          </>
        ) : (
          <DesktopExport
            isDisabled={!data.length || !selectedData.find(el => el.isProcessed)}
          />
        )}
      </HeaderRightSection>
    </Header>
  );
};

export default memo(DesktopHeader);
